/* Great White product page.
   Craft's own code (product-info.js / product-form.js) still runs size changes and add-to-cart.
   This file only keeps our extras in step with it: the button suffix ("— 8 oz · $59.99") and the sticky buy bar. */
(function () {
  function init() {
    var box = document.querySelector('[data-gw-buybox]');
    if (!box || box.dataset.gwReady) return;
    box.dataset.gwReady = '1';

    var info = box.closest('product-info');
    var sectionId = info ? info.dataset.originalSection || info.dataset.section : null;
    var scope = info || document;

    /* Dosing is the question everyone has: on desktop the "How to run it" tab starts open (block id "howto"). */
    if (window.matchMedia('(min-width: 990px)').matches) {
      var howto = scope.querySelector('details[id^="Details-howto-"]');
      if (howto) howto.setAttribute('open', '');
    }

    /* The sticky bar lives on <body> so nothing above it can clip it. Drop stale copies (theme editor re-renders). */
    var bar = scope.querySelector('#gw-sticky');
    document.querySelectorAll('body > #gw-sticky').forEach(function (old) {
      if (old !== bar) old.remove();
    });
    if (!bar) return;
    document.body.appendChild(bar);
    bar.hidden = false;

    var btn = bar.querySelector('#gw-sticky-btn');
    var label = bar.querySelector('[data-gw-sticky-label]');
    var select = bar.querySelector('#gw-sticky-size');
    var buttons = box.querySelector('.product-form__buttons');
    var submit = box.querySelector('.product-form__submit');

    /* Sticky "Add to cart" presses the real button, so Craft's cart pop-up and error handling work as usual. */
    if (btn && submit) {
      btn.addEventListener('click', function () {
        if (submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
        submit.click();
      });
    }

    /* Sticky size picker selects the matching tile, which kicks off Craft's normal variant update. */
    if (select) {
      select.addEventListener('change', function () {
        var radio = box.querySelector('input[type="radio"][data-variant-id="' + select.value + '"]');
        if (radio && !radio.checked) radio.click();
      });
    }

    /* After Craft swaps price + tiles, copy our server-rendered bits out of the same response. */
    function copy(html, selector, root) {
      var from = html.querySelector(selector);
      var to = root.querySelector(selector);
      if (!from || !to) return;
      to.innerHTML = from.innerHTML;
      to.hidden = from.hidden;
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data;
        if (!data || !data.html || (sectionId && data.sectionId !== sectionId)) return;
        copy(data.html, '[data-gw-suffix]', box);
        copy(data.html, '[data-gw-sticky-label]', bar);
        copy(data.html, '[data-gw-sticky-sub]', bar);
        var img = bar.querySelector('.gw-sticky__img');
        var newImg = data.html.querySelector('.gw-sticky__img');
        if (img && newImg) img.src = newImg.getAttribute('src');
        if (data.variant) {
          if (select) select.value = String(data.variant.id);
          if (btn) btn.disabled = !data.variant.available;
        }
      });
    }

    /* Show the bar once the real button has scrolled up out of view; hide it again over the footer. */
    var pastButtons = false;
    var overFooter = false;
    function paint() {
      /* Shopify's theme-preview bar (only present while previewing a draft theme) sits at the bottom too. */
      var preview = document.getElementById('PBarNextFrame');
      var previewBox = preview && preview.parentElement;
      var offset = previewBox ? Math.round(previewBox.getBoundingClientRect().height) : 0;
      bar.style.setProperty('--gw-sticky-offset', offset + 'px');
      bar.classList.toggle('is-on', pastButtons && !overFooter);
    }
    if (buttons && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          var e = entries[0];
          pastButtons = !e.isIntersecting && e.boundingClientRect.top < 80;
          paint();
        },
        { rootMargin: '-64px 0px 0px 0px', threshold: 0 }
      ).observe(buttons);

      var footer = document.querySelector('.shopify-section-group-footer-group, footer');
      if (footer) {
        new IntersectionObserver(
          function (entries) {
            overFooter = entries[0].isIntersecting;
            paint();
          },
          { threshold: 0 }
        ).observe(footer);
      }
    }
  }

  /* "Compare sizes" rows pick that size in the buy box and bring it back into view.
     Without this script the row is still a plain ?variant= link. */
  document.addEventListener('click', function (event) {
    var row = event.target && event.target.closest ? event.target.closest('[data-gw-size]') : null;
    if (!row) return;
    var radio = document.querySelector(
      '[data-gw-buybox] input[type="radio"][data-variant-id="' + row.getAttribute('data-gw-size') + '"]'
    );
    if (!radio) return;
    event.preventDefault();
    if (!radio.checked) radio.click();
    var target = document.querySelector('.product__title') || document.querySelector('[data-gw-buybox]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.pageYOffset - 88;
    window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
